var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"block text-sm font-medium text-gray-700"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.required ? "*" : "")+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }